import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// CRITICAL: Import amplifyConfig FIRST to configure Amplify before any React rendering
import './app/config/amplifyConfig';

import Bootstrap from './app/Bootstrap';

const container = document.getElementById('root');

if (!container) {
  console.error('[main.jsx] ❌ Root container not found!');
} else {
  const root = createRoot(container);

  // Get the base path from Vite's import.meta.env.BASE_URL
  const basename = import.meta.env.BASE_URL || '/';

  root.render(
    <BrowserRouter basename={basename}>
      <Bootstrap />
    </BrowserRouter>
  );
}
